/*
    Display for an individual record for the starter sheet report

    This data will be displayed in one of two modes, controlled by the parent shell:
    Time mode, or Counts mode
    which will display different fields

    This was a way to try to save horizontal screen real estate, 
    while also grouping together related fields
*/

import React from "react";

import DataItem from "../Components/DataItem";
import TimeInput from "../Components/TimeInput";
import { getTimeStringFromDate } from "../Scripts/Utilities";

/*
    <div>Date</div>
    <div>ID</div>
    <div>Run</div>
    <div>Route</div>
    <div>Lane</div>
    <div>Sched</div>
    <div>Act</div>
    <div>Delay</div>
    <div>CAD</div>
*/

/*
        date: "11/02/2020",
        route: "314",
        run: "100",
        lane: "8",
        vehicleID: "4099",
        scheduledTime: "08:35",
        actualTime: "08:47",
        delayInMinutes: "12",
        CAD_Delay: "0",
        passBoarding: "15",
        passArriving: "24",
        passGettingOff: "31",
        passLeftBehind: "2",
        passDeparting: "12"


ActDepTime: ""
Clever: "0"
CleverColor: ""
Color: ""
DepTime: "7:00 A"
Dest: "BwyTrm"
Diff: ""
EarlyStart: ""
InternalTripNumber: "16012142"
LaneGate: "232-1"
Line: "190"
RTN: "820A /190"
Run: "6"
SchedDate: "01-NOV-20"
SchedDepTime: "11/1/2020 7:00:00 AM"
TimingPointID: "NWYKPABT"
VehicleColor: "Black"
VehicleId: "19162"
passArrival: ""
passBoarding: ""
passDeparture: ""
passGetOff: ""
passLeftBehind: ""
*/

export default class ReportStarterData extends React.Component {

    update = (evt) => {
        this.props.updateEntry(evt.target.name, evt.target.value, this.props.index);
    }

    render() {

        const {data} = this.props;

        // convert the passenger counts to integers (or treat as 0 if blank)
        const boarding = data.passBoarding ? parseInt(data.passBoarding) : 0;
        const arriving = data.passArrival ? parseInt(data.passArrival) : 0;
        const gettingOff = data.passGetOff ? parseInt(data.passGetOff) : 0;

        console.log("COUNTS", {pb: data.passBoarding, pa: data.passArrival, pg: data.passGetOff});

        // helper function, to make sure we don't ignore values of 0 despite being falsey
        const checkNonZeroBlank = (val) => {
            return !val && val !== 0;
        }

        // even if we need to treat the values as 0 for the sake of the departing calculation in the else block,
        // if all of the passenger values are blank, then departing has to be blank as well
        let departing = "";
        if(checkNonZeroBlank(data.passBoarding) && checkNonZeroBlank(data.passArrival) && checkNonZeroBlank(data.passGetOff)){
            console.log("SET DEPARTING TO empty string");
            departing = "";
        }
        else {
            console.log("SET DEPARTING TO number");
            departing = arriving + boarding - gettingOff;
        }

        const time = data.DepTime; // getTimeStringFromDate(new Date(data.SchedDepTime));

        const laneField = data.ManualLaneGate ? "ManualLaneGate" : "SchedLaneGate";

        const diff = data.Diff ? `${data.Diff >= 0 ? "+": ""}${data.Diff}M `: "";
        const clever = data.Clever ? `${data.Clever >= 0 ? "+": ""}${data.Clever}M `: "";

        const dataStyle = {padding: "4px", marginBottom: "6px"};

        if(data.Color) {
            dataStyle.backgroundColor = data.Color;
        }

        return (
            <div className="data" style={dataStyle}>
                <div style={{
                    display: "grid",
                    gridTemplateColumns: "3fr 2fr 2fr 2fr 2fr 2fr 3fr 2fr 2fr",
                    gridGap: "4px",
                    justifyItems: "center",
                    alignItems: "center"
                }}>
                    <div><DataItem val={data.SchedDate} /></div>
                    <div><input className="short-input" name="VehicleId" value={data.VehicleId} onChange={this.update} color={`var(--${data.VehicleColor.toLowerCase()})`} /></div>
                    <div><DataItem val={data.Run} /></div>
                    <div><DataItem val={data.Line} /></div>
                    {
                        this.props.mode === "Time"
                        ? <>
                            <div><input className="short-input" name={laneField} value={data[laneField]} onChange={this.update} /></div>
                            <div><DataItem val={time} /></div>
                            <div><TimeInput name="ActDepTime" value={data.ActDepTime} onChange={this.update} nonMilitary={true} /></div>
                            <div><DataItem val={diff} color={data.Color} /></div>
                            <div><DataItem val={clever} color={data.CleverColor} /></div>
                        </>
                        : <>
                            <div><input className="short-input" name="passBoarding" value={data.passBoarding} onChange={this.update} /></div>
                            <div><input className="short-input" name="passArrival" value={data.passArrival} onChange={this.update} /></div>
                            <div><input className="short-input" name="passGetOff" value={data.passGetOff} onChange={this.update} /></div>
                            <div><input className="short-input" name="passLeftBehind" value={data.passLeftBehind} onChange={this.update} /></div>
                            <div><DataItem val={departing} /></div>
                        </>
                    }
                </div>
            </div>
        );
    }
}
